<app-doc-viewer title="Config" subtitle="Core">
  <p>Load config in your angular application</p>

  <li>Import <code>IgoConfigModule</code> only once</li>

  <app-example-viewer
    title="Simple config"
    codeFolder="core/config"
    configFolder="environments"
  >
    <p>Config language: {{ configLanguage | json }}</p>
  </app-example-viewer>
</app-doc-viewer>
